<template>
  <div class="hm-upgrade-plan-modal">
    <HMModalHeader :title="$t(title)" @close="close" />
    <div class="content">
      <img class="mb-4" src="/assets/images/rocket.svg" />
      <p class="text-center" v-html="sanitize($t(description))"></p>
    </div>
    <form @submit.prevent="confirm">
      <HMModalFooter
        :submitButton="$t(confirmButton)"
        :discardButton="$t(discardButton)"
        @close="close"
      />
    </form>
  </div>
</template>

<script>
import { sanitize } from '@/core/utils/utils';

export default {
  name: 'HMUpgradePlanModal',
  components: {},
  props: {
    title: {
      type: String,
      default: 'GENERAL.TITLE.UPGRADE_YOUR_PLAN',
    },
    description: {
      type: String,
    },
    confirmButton: {
      type: String,
      default: 'GENERAL.BUTTON.UPGRADE_NOW',
    },
    discardButton: {
      type: String,
      default: 'GENERAL.BUTTON.GO_BACK',
    },
    onConfirm: { type: Function },
    onDiscard: { type: Function },
  },
  data() {
    return {
      search: '',
      foundImages: [],
      currentPage: 1,
      isLoading: false,
    };
  },
  methods: {
    sanitize,
    confirm() {
      if (this.onConfirm) this.onConfirm();
      this.$emit('close');
    },
    close() {
      if (this.onDiscard) this.onDiscard();
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.content {
  background-color: $light-bubblegum;
  border-radius: $border-radius;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 5rem;
  color: $charcoal;

  @include media-breakpoint-down(md) {
    padding: 2rem 3rem;
  }
}
</style>
